import React from 'react';
import Icon, { fillTypes } from '../Icon/Icon';

import LogoSquare from '../Logos/LogoSquare';

const Footer = (): JSX.Element => {
    return (
        <footer className="bg-default text-white px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-24 mx-auto max-w-custom960">
                <div>
                    <div className="mb-6">
                        <LogoSquare />
                    </div>
                    <div className="flex gap-4 lg:gap-2 lg:flex-col">
                        <a className="block note text-white" title="View our terms & consitions" href="/terms-and-conditions">Terms & Conditions</a>
                        <a className="block note text-white" title="View our privacy policy" href="/privacy-policy">Privacy Policy</a>
                    </div>
                </div>
                <div>
                    <div className="mb-6">
                        <div className="label mb-2">Phone</div>
                        <a className="block note text-white" href="tel:+442088956487" title="Call us">+44 208 895 6487</a>
                    </div>
                    <div>
                        <div className="label mb-2">Email</div>
                        <a className="block note text-white" title="Email us" href="mailto:hello@changemyface.com">hello@changemyface.com</a>
                    </div>
                </div>
                <div>
                    <div className="label mb-2">Social</div>
                    <div className="flex gap-4 items-center">
                        <a
                            href="https://twitter.com/changemyface"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            title="View our Twitter page"
                        >
                            <Icon size={24} fill={fillTypes.white}>
                                <Icon.Twitter />
                            </Icon>
                        </a>
                        <a
                            href="https://www.instagram.com/changemyface_software/"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            title="View our instagram"
                        >
                            <Icon size={24} fill={fillTypes.white}>
                                <Icon.Instagram />
                            </Icon>
                        </a>
                    </div>
                </div>
                <div>
                    <div className="label mb-2">Office</div>
                    <address>
                        1A Frogmore House, <br />
                        Ormond Place, <br />
                        Cheltenham, <br />
                        Glos, <br />
                        GL50 1JD, <br />
                        United Kingdom
                    </address>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
